// Module
var code = "<h3>Message preferences</h3> <div class=\"listingTableContainer\"> <table id=\"messagePrefsTable\"> <thead id=\"messagePrefsTableHead\"></thead> <tbody id=\"messagePrefsTableBody\"></tbody> </table> </div> ";
// Exports
export default code;